import { render, staticRenderFns } from "./cooperativeAlliance.vue?vue&type=template&id=e63c1fd6&scoped=true&"
import script from "./cooperativeAlliance.vue?vue&type=script&lang=js&"
export * from "./cooperativeAlliance.vue?vue&type=script&lang=js&"
import style0 from "./cooperativeAlliance.vue?vue&type=style&index=0&id=e63c1fd6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e63c1fd6",
  null
  
)

export default component.exports